import {RootState} from "../../../../store";

export const getPersonalChatError = (state: RootState) => state.personalChatsReducer.error;
export const getPersonalChatIsLoading = (state: RootState) => state.personalChatsReducer.isLoading;
export const getPersonalChatIsLoadingPersonalChat = (state: RootState) => state.personalChatsReducer.isLoadingPersonalChat;
export const getPersonalChatIsMounted = (state: RootState) => state.personalChatsReducer.isMounted;
export const getPersonalChatMyCollection = (state: RootState) => state.personalChatsReducer.myCollection;
